import { Controller } from "@hotwired/stimulus"
import { confirmDialog } from "../lib/confirm_dialog"

// The "Iniciar jogo" button on /ao-vivo only ever shows for a game
// scheduled for today (see Games::LiveController#index), so that flow
// can't start the wrong day's match by accident. But the game edit form
// also has a raw "status" dropdown (meant for admin corrections — see
// games/_form.html.erb) that lets anyone flip status straight to "live"
// or "finished" for ANY game, any date, with no such guard. This adds one:
// if the referee changes status away from "scheduled" on a form that
// initially loaded as scheduled and isn't scheduled_at today, ask for
// confirmation before letting the submit go through.
export default class extends Controller {
  static targets = ["status"]
  static values = { scheduledToday: Boolean, message: String }

  connect() {
    this.originalStatus = this.statusTarget.value
  }

  async confirmSubmit(event) {
    const changingToLiveOrFinished =
      this.originalStatus === "scheduled" &&
      this.statusTarget.value !== "scheduled" &&
      this.statusTarget.value !== this.originalStatus

    if (!this.scheduledTodayValue && changingToLiveOrFinished) {
      event.preventDefault()
      if (await confirmDialog(this.messageValue)) {
        // Já confirmado: atualiza o status "original" pra não perguntar de novo.
        this.originalStatus = this.statusTarget.value
        event.target.requestSubmit()
      }
    }
  }
}
